/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { CTAImage } from "cms/components/components/call-to-action/display/image";
import { CTALink } from "cms/components/components/call-to-action/display/link";
import { isArrayNotEmpty, isStringNotEmpty, isRichTextNotEmpty } from "utils/empty-exists";

const CTAVertical = (props) => {
    const {
        image,
        title,
        description,
        links,
        style,
        format,
    } = props;
    
    return (
        <div className={"cta-container vertical"}>
            {image &&
                <CTAImage
                    image={image}
                    imageCard='vertical'
                />
            }
            
            <div className={"simplicity-cta-content vertical"}>
                {isStringNotEmpty(title) &&
                    <h2 className='simplicity-cta-title'>{title}</h2>
                }
                {/*<div className='cta-content-lower'>*/}
                {isRichTextNotEmpty(description) &&
                        <RichTextPreview richtext={description} />
                }
                {isArrayNotEmpty(links) &&
                        links.map((link, idx) => (
                            <CTALink
                                key={idx}
                                idx={idx}
                                link={link}
                                style={style}
                                format={format}
                            />
                        ))
                }
                {/*</div>*/}
            </div>
        </div>
    );
};
CTAVertical.displayName = "CTAVertical";
export { CTAVertical };
